// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import UploadedFileEditScreen from "../../src/screens/uploaded-files/edit-screen"
import ScreenTitle from "../../src/components/screen-title"


/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} UploadedFileNewRouteProps */

/** @typedef {Record<string, never>} UploadedFileNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<UploadedFileNewRouteProps, UploadedFileNewRouteState>}
 */
class UploadedFileNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New file")}</ScreenTitle>
        <UploadedFileEditScreen />
      </>
    )
  }
}


/** @type {NamedExoticComponent<UploadedFileNewRouteProps>} */
const UploadedFileNewRouteComponent = memo(shapeComponent(UploadedFileNewRoute))

export default UploadedFileNewRouteComponent
